import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutPricingItems = {
  factory: EElement({
    id: '4853f42b-e1bf-4f91-d78e-67bcbe1d974f',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('db2f1ab4-cb0f-9624-5e34-7c85c6c0e564')]),
      children: EList([
        EElement({
          id: '4853f42b-e1bf-4f91-d78e-67bcbe1d9750',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '12739eb1-1dbd-6222-d6f0-a9a2cf8f9570',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('5253c8ca-1b3e-5a0a-0f14-46523f464687'),
                  ]),
                  children: EList([
                    EElement({
                      id: '1c6bc492-4cc7-4a55-4dad-13e6dd4c0f3a',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('cd3c7681-7b69-6382-5141-e8e32a951e85'),
                        ]),
                        children: EList([
                          EElement({
                            id: '5654cc61-1c30-4390-dda0-e6f7b0edd5e7',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageSun),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627377c45b0142e2cf5ffe85"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('0c4eae2f-c398-01cf-7c67-91684468f0df'),
                                EText('6aec22fd-05f0-2e66-22b9-df01f7122a57'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '47daee6a-14a5-2509-d199-43c5c834a8a9',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('a9975719-38bd-ef36-5434-4a20d7b3ce78'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'bfafae33-4b31-2793-48c3-087b1c74b2a6',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    styleBlockIds: EList([
                                      EText(
                                        '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'bfafae33-4b31-2793-48c3-087b1c74b2a7',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Dual Income'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '15986cd9-218e-6384-a1f6-3f43aa23268b',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'd4b43db9-3147-67f5-1d2e-d769a2a49793'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'fb2365de-f1af-f6db-3ede-9d172ba78548',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Heading')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('h3'),
                                          children: EList([
                                            EElement({
                                              id: 'fb2365de-f1af-f6db-3ede-9d172ba78549',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('Aberglasslyn, NSW'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '0716d108-dbec-dea2-0a23-a0303ed5aa88',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Heading')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('h3'),
                                          children: EList([
                                            EElement({
                                              id: '0716d108-dbec-dea2-0a23-a0303ed5aa89',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('$723,999'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '2b0424e5-d10c-88b8-c3b9-98f5445edddb',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '9c5baded-3d7a-d179-e911-b19b1a98d699'
                                      ),
                                    ]),
                                    children: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '7c6569b6-1f6b-1ecd-c4c8-4ca6e68c2697',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '73d09577-26ee-232f-938d-0754bc5cde4e'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'f62829f3-2386-e912-a4ac-96cc66cd66eb',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '76e1ce3f-11bb-a878-44dd-d82a7105c1a8'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'c679ed0f-9363-d2d6-8fa4-ca9e9091e4c9',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5e359d85-5957-122f-f386-a0a623e486c3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'c679ed0f-9363-d2d6-8fa4-ca9e9091e4ca',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('$18,245'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '8c5622ad-4f26-0f1e-c0ba-56c2e3d079d5',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '8c5622ad-4f26-0f1e-c0ba-56c2e3d079d6',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Project Income'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'f2d2863c-b2da-b2ca-ae4d-e27af01e7d1e',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '76e1ce3f-11bb-a878-44dd-d82a7105c1a8'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'f2d2863c-b2da-b2ca-ae4d-e27af01e7d1f',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5e359d85-5957-122f-f386-a0a623e486c3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'f2d2863c-b2da-b2ca-ae4d-e27af01e7d20',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('8%'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'f2d2863c-b2da-b2ca-ae4d-e27af01e7d21',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'f2d2863c-b2da-b2ca-ae4d-e27af01e7d22',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Project yield'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'cadde85d-b7d3-c6f1-3fdb-814655133c7a',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '76e1ce3f-11bb-a878-44dd-d82a7105c1a8'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'cadde85d-b7d3-c6f1-3fdb-814655133c7b',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5e359d85-5957-122f-f386-a0a623e486c3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'cadde85d-b7d3-c6f1-3fdb-814655133c7c',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('12.2%'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'cadde85d-b7d3-c6f1-3fdb-814655133c7d',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'cadde85d-b7d3-c6f1-3fdb-814655133c7e',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Project growth'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '16b8b34e-3e25-0997-5b00-b6f3f005bca3',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('cd3c7681-7b69-6382-5141-e8e32a951e85'),
                        ]),
                        children: EList([
                          EElement({
                            id: '16b8b34e-3e25-0997-5b00-b6f3f005bca4',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageHills),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627377c45b0142e2cf5ffe73"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('0c4eae2f-c398-01cf-7c67-91684468f0df'),
                                EText('6aec22fd-05f0-2e66-22b9-df01f7122a57'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '16b8b34e-3e25-0997-5b00-b6f3f005bca5',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('a9975719-38bd-ef36-5434-4a20d7b3ce78'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '16b8b34e-3e25-0997-5b00-b6f3f005bca6',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    styleBlockIds: EList([
                                      EText(
                                        '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '16b8b34e-3e25-0997-5b00-b6f3f005bca7',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Dual Income'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '16b8b34e-3e25-0997-5b00-b6f3f005bca8',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'd4b43db9-3147-67f5-1d2e-d769a2a49793'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '16b8b34e-3e25-0997-5b00-b6f3f005bca9',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Heading')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('h3'),
                                          children: EList([
                                            EElement({
                                              id: '16b8b34e-3e25-0997-5b00-b6f3f005bcaa',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('Aberglasslyn, NSW'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '16b8b34e-3e25-0997-5b00-b6f3f005bcab',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Heading')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('h3'),
                                          children: EList([
                                            EElement({
                                              id: '16b8b34e-3e25-0997-5b00-b6f3f005bcac',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('$723,999'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '16b8b34e-3e25-0997-5b00-b6f3f005bcad',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '9c5baded-3d7a-d179-e911-b19b1a98d699'
                                      ),
                                    ]),
                                    children: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '16b8b34e-3e25-0997-5b00-b6f3f005bcae',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '73d09577-26ee-232f-938d-0754bc5cde4e'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '16b8b34e-3e25-0997-5b00-b6f3f005bcaf',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '76e1ce3f-11bb-a878-44dd-d82a7105c1a8'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '16b8b34e-3e25-0997-5b00-b6f3f005bcb0',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5e359d85-5957-122f-f386-a0a623e486c3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '16b8b34e-3e25-0997-5b00-b6f3f005bcb1',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('$18,245'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '16b8b34e-3e25-0997-5b00-b6f3f005bcb2',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '16b8b34e-3e25-0997-5b00-b6f3f005bcb3',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Project Income'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '16b8b34e-3e25-0997-5b00-b6f3f005bcb4',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '76e1ce3f-11bb-a878-44dd-d82a7105c1a8'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '16b8b34e-3e25-0997-5b00-b6f3f005bcb5',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5e359d85-5957-122f-f386-a0a623e486c3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '16b8b34e-3e25-0997-5b00-b6f3f005bcb6',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('8%'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '16b8b34e-3e25-0997-5b00-b6f3f005bcb7',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '16b8b34e-3e25-0997-5b00-b6f3f005bcb8',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Project yield'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '16b8b34e-3e25-0997-5b00-b6f3f005bcb9',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '76e1ce3f-11bb-a878-44dd-d82a7105c1a8'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '16b8b34e-3e25-0997-5b00-b6f3f005bcba',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5e359d85-5957-122f-f386-a0a623e486c3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '16b8b34e-3e25-0997-5b00-b6f3f005bcbb',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('12.2%'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '16b8b34e-3e25-0997-5b00-b6f3f005bcbc',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '16b8b34e-3e25-0997-5b00-b6f3f005bcbd',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Project growth'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef884',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('cd3c7681-7b69-6382-5141-e8e32a951e85'),
                        ]),
                        children: EList([
                          EElement({
                            id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef885',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageMountains),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627377c45b0142e2cf5ffe9c"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('0c4eae2f-c398-01cf-7c67-91684468f0df'),
                                EText('6aec22fd-05f0-2e66-22b9-df01f7122a57'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef886',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('a9975719-38bd-ef36-5434-4a20d7b3ce78'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef887',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    styleBlockIds: EList([
                                      EText(
                                        '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef888',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Dual Income'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef889',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'd4b43db9-3147-67f5-1d2e-d769a2a49793'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef88a',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Heading')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('h3'),
                                          children: EList([
                                            EElement({
                                              id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef88b',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('Aberglasslyn, NSW'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef88c',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Heading')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('h3'),
                                          children: EList([
                                            EElement({
                                              id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef88d',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('$723,999'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef88e',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '9c5baded-3d7a-d179-e911-b19b1a98d699'
                                      ),
                                    ]),
                                    children: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef88f',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '73d09577-26ee-232f-938d-0754bc5cde4e'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef890',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '76e1ce3f-11bb-a878-44dd-d82a7105c1a8'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef891',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5e359d85-5957-122f-f386-a0a623e486c3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef892',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('$18,245'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef893',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef894',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Project Income'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef895',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '76e1ce3f-11bb-a878-44dd-d82a7105c1a8'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef896',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5e359d85-5957-122f-f386-a0a623e486c3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef897',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('8%'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef898',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef899',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Project yield'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef89a',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '76e1ce3f-11bb-a878-44dd-d82a7105c1a8'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef89b',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5e359d85-5957-122f-f386-a0a623e486c3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef89c',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('12.2%'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef89d',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Paragraph')
                                              ),
                                              data: ERecord({
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '0cbd5414-1f4a-93ac-fce7-6ca31d1ef89e',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Project growth'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: 'db2f1ab4-cb0f-9624-5e34-7c85c6c0e564',
      type: 'class',
      name: 'Pricing Items',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '5253c8ca-1b3e-5a0a-0f14-46523f464687',
      type: 'class',
      name: 'Pricing Wrapper Two',
      comb: '',
      styleLess: 'display: flex; margin-bottom: -40px; flex-direction: column;',
      children: [],
      variants: {},
    },
    {
      _id: 'cd3c7681-7b69-6382-5141-e8e32a951e85',
      type: 'class',
      name: 'Pricing Card Two',
      comb: '',
      styleLess:
        'display: flex; margin-bottom: 40px; padding-top: 40px; padding-right: 32px; padding-bottom: 40px; padding-left: 32px; justify-content: space-between; background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        medium: {
          styleLess:
            'padding-top: 24px; padding-right: 24px; padding-bottom: 24px; padding-left: 24px; align-items: center;',
        },
        small: {
          styleLess:
            'flex-direction: column; justify-content: flex-start; align-items: stretch;',
        },
        tiny: {
          styleLess:
            'padding-top: 15px; padding-right: 15px; padding-bottom: 15px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '0c4eae2f-c398-01cf-7c67-91684468f0df',
      type: 'class',
      name: 'Pricing Image Two',
      comb: '',
      styleLess: 'max-width: 30%; margin-right: 40px;',
      children: ['6aec22fd-05f0-2e66-22b9-df01f7122a57'],
      variants: {
        small: {
          styleLess: 'max-width: 100%; margin-right: 0px; margin-bottom: 30px;',
        },
        medium: {styleLess: 'margin-right: 20px;'},
      },
    },
    {
      _id: '6aec22fd-05f0-2e66-22b9-df01f7122a57',
      type: 'class',
      name: 'Shadow Two',
      comb: '&',
      styleLess: '',
      children: [],
      variants: {},
    },
    {
      _id: 'a9975719-38bd-ef36-5434-4a20d7b3ce78',
      type: 'class',
      name: 'Pricing Content',
      comb: '',
      styleLess:
        'display: flex; padding-top: 16px; padding-right: 16px; padding-bottom: 16px; padding-left: 16px; flex-direction: column; flex-grow: 1; flex-shrink: 1; flex-basis: 0%; background-color: hsla(0, 0.00%, 100.00%, 1.00);',
      children: [],
      variants: {},
    },
    {
      _id: '8af53af0-f60d-5b01-c583-17ee60d4d532',
      type: 'class',
      name: 'Tagline',
      comb: '',
      styleLess: 'margin-bottom: 10px; font-size: 12px; line-height: 16px;',
      children: [],
      variants: {},
    },
    {
      _id: 'd4b43db9-3147-67f5-1d2e-d769a2a49793',
      type: 'class',
      name: 'Pricing Info',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-between; align-items: center;',
      children: [],
      variants: {
        tiny: {
          styleLess:
            'flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
      },
    },
    {
      _id: '9c5baded-3d7a-d179-e911-b19b1a98d699',
      type: 'class',
      name: 'Pricing Divider Two',
      comb: '',
      styleLess:
        'height: 1px; margin-top: 9px; margin-right: -16px; margin-bottom: 16px; margin-left: -16px; background-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {},
    },
    {
      _id: '73d09577-26ee-232f-938d-0754bc5cde4e',
      type: 'class',
      name: 'Pricing Details',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-between; align-items: flex-start;',
      children: [],
      variants: {
        tiny: {
          styleLess:
            'margin-bottom: -10px; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
      },
    },
    {
      _id: '76e1ce3f-11bb-a878-44dd-d82a7105c1a8',
      type: 'class',
      name: 'Pricing Block',
      comb: '',
      styleLess: 'margin-bottom: -10px;',
      children: [],
      variants: {tiny: {styleLess: 'margin-bottom: 10px;'}},
    },
    {
      _id: '5e359d85-5957-122f-f386-a0a623e486c3',
      type: 'class',
      name: 'Pricing Details Text',
      comb: '',
      styleLess: 'margin-bottom: 8px;',
      children: [],
      variants: {},
    },
  ],
} as const;
